import React from "react";
import { useAnalisisDRC } from "../hooks/useAnalisisDRC";
import { useDatosDRC } from "../hooks/useDatosDRC";
import LoadMask from "Utils/LoadMask/LoadMask";
import { DatosAnalisis } from "./DatosAnalisis";
import { DatosDRC } from "./DatosDRC/DatosDRC";
import { useContaminantes } from "../hooks/useContaminantes";
import { Contaminantes } from "./Contaminantes";
import { FechaHoraAnalisis } from "./FechaHoraAnalisis";
import { Observaciones } from "./Observaciones";

export const AnalisisForm = (props) => {
    const { analisisId, modo, regresar, rangoDRC, setTipoSolicitud } = props;

    const {
        analisisDetalle,

        fechaAnalisis,
        setFechaAnalisis,
        horaAnalisis,
        setHoraAnalisis,
        observaciones,
        setObservaciones,

        AsignarDRC,
        ValidarDRC,
        RechazarDRC,
        GuardarAnalisisDRC,

        cargando,
    } = useAnalisisDRC(analisisId, setTipoSolicitud, regresar);

    const datosDRCHook = useDatosDRC(analisisDetalle);
    const { datosDRC } = datosDRCHook;

    const {
        contaminantes,
        loadContaminantes,
        Agregar: AgregarContaminante,
        Eliminar: EliminarContaminante,
        Actualizar: ActualizarContaminante,
    } = useContaminantes(analisisDetalle);

    const isModoAnalisis = modo === "analisis";

    let btnsAccion = null;
    if (isModoAnalisis) {
        btnsAccion = (
            <React.Fragment>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => GuardarAnalisisDRC(datosDRC, contaminantes)}
                >
                    Guardar
                </button>

                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => AsignarDRC(datosDRC, contaminantes)}
                    disabled={datosDRC.length === 0}
                >
                    Enviar a validación
                </button>
            </React.Fragment>
        );
    } else if (modo === "validacion") {
        btnsAccion = (
            <React.Fragment>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => ValidarDRC()}
                >
                    Validar DRC
                </button>

                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => RechazarDRC()}
                >
                    Rechazar DRC
                </button>
            </React.Fragment>
        );
    }

    return (
        <LoadMask loading={cargando} blur>
            <DatosAnalisis
                analisisActual={analisisDetalle && analisisDetalle.analisis}
                detalle={analisisDetalle && analisisDetalle.detalle}
            />
            <FechaHoraAnalisis
                fechaAnalisis={fechaAnalisis}
                setFechaAnalisis={setFechaAnalisis}
                horaAnalisis={horaAnalisis}
                setHoraAnalisis={setHoraAnalisis}
                isModoAnalisis={isModoAnalisis}
            />
            <DatosDRC
                datosDRCHook={datosDRCHook}
                rangoDRC={rangoDRC}
                isModoAnalisis={isModoAnalisis}
            />
            <Contaminantes
                contaminantes={contaminantes}
                loadContaminantes={loadContaminantes}
                Agregar={AgregarContaminante}
                Eliminar={EliminarContaminante}
                Actualizar={ActualizarContaminante}
                isModoAnalisis={isModoAnalisis}
            />
            <Observaciones
                observaciones={observaciones}
                setObservaciones={setObservaciones}
                isModoAnalisis={isModoAnalisis}
            />

            <div
                className="d-flex justify-content-center mt-4 mb-0"
                style={{ gap: "2rem" }}
            >
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                {btnsAccion}
            </div>
        </LoadMask>
    );
};
